'use client';

import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { Button } from "@/components/ui/button"
import LanguageDropdown from './LanguageDropdown';

const Header: React.FC = () => {
  const router = useRouter()
  const handleSubscribeClick = (e: React.MouseEvent) => {
    e.preventDefault()
    router.push('/contact-us?subscribe=true')
  }

  return (
    <header className="sticky top-0 z-50 w-full bg-[#5f4664] text-white py-4">
      <div className="container mx-auto flex items-center justify-between px-4">
        {/* Logo */}
        <Link href="/" className="text-3xl font-bold tracking-wider">
          EWORLD
        </Link>
        {/* Navigation with more spacing and right alignment */}
        <div className="flex items-center justify-end flex-1 ml-20">
          <nav className="hidden lg:flex space-x-8 text-[11px] tracking-wider mr-8">
            <Link 
              href="/what-is-eworld" 
              className="hover:text-[#c39bd3] transition-colors uppercase"
            >
              What is EWORLD
            </Link>
            <Link 
              href="/why-eworld" 
              className="hover:text-[#c39bd3] transition-colors uppercase"
            >
              Why EWORLD
            </Link>
            <Link 
              href="/pricing" 
              className="hover:text-[#c39bd3] transition-colors uppercase"
            >
              Pricing
            </Link>
            <Link 
              href="/our-partners" 
              className="hover:text-[#c39bd3] transition-colors uppercase"
            >
              Our Partners
            </Link>
            <Link 
              href="/about-us" 
              className="hover:text-[#c39bd3] transition-colors uppercase"
            >
              About Us
            </Link>
            <Link 
              href="/investor-invitation" 
              className="hover:text-[#c39bd3] transition-colors uppercase"
            >
              Investors
            </Link>
            <Link 
              href="/media" 
              className="hover:text-[#c39bd3] transition-colors uppercase"
            >
              Media
            </Link>
            <Link 
              href="/contact-us" 
              className="hover:text-[#c39bd3] transition-colors uppercase"
            >
              Contact
            </Link>
          </nav>
          {/* Vertical button stack - moved right with padding */}
          <div className="flex flex-col space-y-2 pr-6">
            {/* Google Translate Element - Hidden but functional */}
            <div id="google_translate_element" style={{ position: 'absolute', top: '-9999px', left: '-9999px' }}></div>
            
            {/* Language Dropdown - replaced the previous button completely */}
            <LanguageDropdown />

            <Button 
              variant="ghost" 
              size="sm" 
              className="text-[10px] h-auto px-2 py-1 text-white border border-white rounded-full hover:bg-white hover:text-[#9b59b6] transition-all duration-200 transform hover:scale-105 whitespace-nowrap"
              onClick={handleSubscribeClick}
              aria-label="Subscribe to waitlist"
            >
              Subscribe Waitlist
            </Button>
            {/* Muted "Start Trial" button */}
            {/* Uncomment the following button when you want to reactivate it
            <Button 
              variant="ghost" 
              size="sm" 
              className="text-[10px] h-5 px-2 py-0 text-white border border-white rounded-full hover:bg-white hover:text-[#9b59b6] transition-all duration-200 transform hover:scale-105"
            >
              Start Trial
            </Button>
            */}
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header